import React from 'react';
import { LoadingSpinner } from '@doxyme/ui';
import './on-page-loader.scss';
export const OnPageLoader = ({ label = '' }) => (<div className="on-page-loader">
            <LoadingSpinner label={label}/>
          </div>);
